import styled from "styled-components";

export const DrawerStyled = styled.div`
  min-height: 100vh;
  max-height: 100%;
  height: 100%;
  background-color: #f6f6fe !important;

  .content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
  }

  .rate {
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: ${({ expanded }) =>
      expanded ? "flex-end" : "auto"} !important;
  }

  .expanded .rate {
    .MuiInputBase-root {
      width: ${({ expanded }) => (expanded ? "200px" : "auto")} !important;
    }
  }
`;
